
import Api from './api'
import {getCookies} from '@/utils/cookies'
function CallCenterCrmModal () {
  if (!(this instanceof CallCenterCrmModal)) {
    return new CallCenterCrmModal()
  }
}
// ++++++++++++++++++++++++++++ user login and user data api call start ++++++++++++++++++++++++++++
// var keyStr = 'Cal#45E42@a'
/*
* Call Cetner CRM login api
*/
// Email Verify
CallCenterCrmModal.prototype.emailVerify = async function (
  email,
  platform,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('email', email)
  data.append('platform', platform)
  Api.emailVerify(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Login User
CallCenterCrmModal.prototype.login = async function (
  emailToken,
  password,
  platform,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('emailToken', emailToken)
  data.append('password', password)
  data.append('platform', platform)
  Api.login(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.getUserLoginPermission = async function (
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('authToken', getCookies('authToken'))
  Api.getUserLoginPermission(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Role Api Start here....
CallCenterCrmModal.prototype.getPermissionList = async function (
  roleId,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('roleId', roleId)
  Api.getPermissionList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.addNewRole = async function (
  roleDetail,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('roleDetail', roleDetail)
  Api.addNewRole(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.getRoleList = async function (
  viewInActive,
  sortColumnName,
  sortColumnOrder,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('viewInActive', viewInActive)
  data.append('sortColumnName', sortColumnName)
  data.append('sortColumnOrder', sortColumnOrder)
  Api.getRoleList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.getRoleDetails = async function (
  roleId,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('roleId', roleId)
  Api.getRoleDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Company Api Start
CallCenterCrmModal.prototype.getCompanyData = async function (
  groupName,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('groupName', groupName)
  Api.getCompanyData(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.updateCompanyData = async function (
  generalSettingList,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('generalSettingList', generalSettingList)
  Api.updateCompanyData(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.uploadComapnyLogo = async function (
  logoDetail,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('logoDetail', logoDetail)
  Api.uploadComapnyLogo(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.uploadfileInTemp = async function (
  file,
  callBackFunc,
  onError
) {
  let data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('file', file)
  Api.uploadfileInTemp(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CallCenterCrmModal.prototype.deleteMultipleFileFromTemp = async function (
  deleteFileObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('deleteFileObj', JSON.stringify(deleteFileObj))
  Api.deleteMultipleFileFromTemp(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CallCenterCrmModal.prototype.globalCompanySearch = async function (
  searchValue,
  start,
  length,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('searchValue', searchValue)
  data.append('start', start)
  data.append('length', length)
  Api.globalCompanySearch(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CallCenterCrmModal.prototype.globalCompanySearchByNumberEmail = async function (
  searchValue,
  searchType,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('searchValue', searchValue)
  data.append('searchType', searchType)
  Api.globalCompanySearchByNumberEmail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
export default CallCenterCrmModal



// WEBPACK FOOTER //
// ./src/api/CallCenterCrmModal.js